<template>
  <el-form label-position="right" label-width="140px">
    <el-divider content-position="left">Valores a pagar</el-divider>
    <div class="row">
      <div class="col-xl-4 col-sm-6 mb-xl-0 mb-4">
        <div class="card" style="height: 100px;">
          <div class="card-body p-3">
            <div class="row">
              <div class="col-9">
                <div class="numbers">
                  <p class="text-sm mb-0 text-uppercase font-weight-bold">Valor Total</p>
                  <h5 class="font-weight-bolder">
                    {{
                      total
                      | currency("R$ ", 2, {
                        thousandsSeparator: ".",
                        decimalSeparator: ",",
                      })
                    }}
                  </h5>
                </div>
              </div>
              <div class="col-3 text-end">
                <div class="icon icon-shape bg-gradient-info shadow-primary text-center rounded-circle">
                  <i class="ni ni-money-coins text-lg opacity-10" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-sm-6 mb-xl-0 mb-4">
        <div class="card" style="height: 100px;">
          <div class="card-body p-3">
            <div class="row">
              <div class="col-9">
                <div class="numbers">
                  <p class="text-sm mb-0 text-uppercase font-weight-bold">Desconto</p>
                  <h5 class="font-weight-bolder red">
                    <el-input
                      ref="discount"
                      type="number"
                      style="width: 250px;"
                      pattern="^\\$?(([1-9](\\d*|\\d{0,2}(,\\d{3})*))|0)(\\.\\d{1,2})?$"
                      :controls="false"
                      :min="0"
                      :max="max"
                      v-model="discount"
                    >
                      <el-radio-group v-model="type" slot="append">
                        <el-radio label="0" class="uppercase">%</el-radio>
                        <el-radio label="1" class="uppercase">$</el-radio>
                      </el-radio-group>
                    </el-input>
                  </h5>
                </div>
              </div>
              <div class="col-3 text-end">
                <div class="icon icon-shape bg-gradient-warning shadow-primary text-center rounded-circle">
                  <i class="fa fa-arrow-down text-lg opacity-10" style="color: white" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-sm-6 mb-xl-0 mb-4">
        <div class="card" style="height: 100px;">
          <div class="card-body p-3">
            <div class="row">
              <div class="col-9">
                <div class="numbers">
                  <p class="text-sm mb-0 text-uppercase font-weight-bold">Valor a Pagar</p>
                  <h5 class="font-weight-bolder red">
                    {{
                      pay
                      | currency("R$ ", 2, {
                        thousandsSeparator: ".",
                        decimalSeparator: ",",
                      })
                    }}
                  </h5>
                </div>
              </div>
              <div class="col-3 text-end">
                <div class="icon icon-shape bg-gradient-primary shadow-primary text-center rounded-circle">
                  <i class="ni ni-cart text-lg opacity-10" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-sm-6 mb-xl-0 mb-4">
        <div class="card" style="height: 100px;">
          <div class="card-body p-3">
            <div class="row">
              <div class="col-9">
                <div class="numbers">
                  <p class="text-sm mb-0 text-uppercase font-weight-bold">Adicionais</p>
                  <h5 class="font-weight-bolder green">
                    <el-input
                      v-model="aditional"
                      style="width: 250px;"
                      placeholder="ex: 1.000,00"
                    >
                    <template slot="append">R$</template>
                    </el-input>
                  </h5>
                </div>
              </div>
              <div class="col-3 text-end">
                <div class="icon icon-shape bg-gradient-success shadow-primary text-center rounded-circle">
                  <i class="fa fa-plus text-lg opacity-10" style="color: white" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-divider content-position="left">Pagamento do atendimento</el-divider>
    <el-row :gutter="5">
      <el-col :xs="24" :sm="16" :md="18" :lg="18" :xl="20">
        <el-checkbox v-model="payment">Utilizar duas formas de pagamento</el-checkbox>
      </el-col>
    </el-row>
    <PdvClosedValuesTwo v-if="payment" ref="payment1" :licence="licence" :pay="pay" />
    <PdvClosedValuesOne v-else ref="payment2" :licence="licence" :pay="pay" />
  </el-form>
</template>

<script>
import PdvClosedValuesTwo from './PdvClosedValuesTwo';
import PdvClosedValuesOne from './PdvClosedValuesOne';

export default {
  components: {
    PdvClosedValuesOne,
    PdvClosedValuesTwo,
  },
  props: ['licence'],
  name: 'PdvClosedValues',
  data() {
    return {
      type: '0',          // '0' = % | '1' = R$
      payment: false,
      total: 0,
      discount: 0,        
      aditional: '',      // <- string para aceitar "1.234,56"
    };
  },
  computed: {
    max() {
      const vm = this;
      if (vm.type === '0') return 100;
      return +vm.total;
    },
    pay() {
      // usa parseNumberFlexible para normalizar qualquer entrada
      const totalNum = this.parseNumberFlexible(this.total);
      const aditionalNum = this.parseNumberFlexible(this.aditional);
      const discountNum = this.parseNumberFlexible(this.discount);

      const base = totalNum + aditionalNum;

      if (this.type === '0') {
        const pct = Math.min(Math.max(discountNum, 0), 100);
        const value = base - base * (pct / 100);
        return +value.toFixed(2);
      }

      const value = Math.max(0, base - discountNum);
      return +value.toFixed(2);
    },
  },
  methods: {
    parseNumberFlexible(v) {
      if (v === null || v === undefined) return 0;
      let s = String(v).trim();

      // remove tudo que não seja dígito, ponto, vírgula ou sinal de negativo
      s = s.replace(/[^0-9.,-]/g, '');

      if (s === '' || s === '-' || s === ',' || s === '.') return 0;

      const hasDot = s.indexOf('.') !== -1;
      const hasComma = s.indexOf(',') !== -1;

      if (hasDot && hasComma) {
        // quem aparece por último é o separador decimal
        const lastDot = s.lastIndexOf('.');
        const lastComma = s.lastIndexOf(',');
        if (lastComma > lastDot) {
          // formato BR: "1.234,56" -> remove pontos milhares, vírgula -> ponto decimal
          s = s.replace(/\./g, '').replace(',', '.');
        } else {
          // formato EN: "1,234.56" -> remove vírgulas milhares
          s = s.replace(/,/g, '');
        }
      } else if (hasComma) {
        // apenas vírgula: tratar como decimal -> "1234,56" -> "1234.56"
        s = s.replace(/\./g, '').replace(',', '.');
      } else {
        // apenas ponto ou nenhum: remover vírgulas só pra garantir (ex: "1,234" -> "1234")
        s = s.replace(/,/g, '');
      }

      const n = parseFloat(s);
      return isNaN(n) ? 0 : n;
    }, 
    paymentData() {
      return {
        type: this.type,
        aditional: this.parseNumberFlexible(this.aditional),
        total: this.total,
        discount: this.discount,
        paymentType: this.payment ? this.$refs.payment1.paymentData() : this.$refs.payment2.paymentData(),
      };
    },
    clear() {
      this.type = '0';
      this.payment = false;
      this.discount = 0;
      this.aditional = '';
      this.total = 0;
      if (this.$refs.payment1) this.$refs.payment1.clear();
      else if (this.$refs.payment2) this.$refs.payment2.clear();
    },
    add(value) {
      this.total += value;
    },
    remove(value) {
      this.total -= value;
    },
  },
};
</script>

<style>
.red { color: red; }
.green { color: #67C23A; }
.ni { color: #ffffff !important; }
</style>